import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { EnvService } from './services/env.service';
import { Events } from './services/events.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'logipro';

	constructor(
		private http: HttpClient,
		private env: EnvService,
		public events: Events
	) {
		/*
		this.events.subscribe('user:login', (data: any) => {
			this.http.get(this.env.API_URL + 'api/user.data.php?userid='+data).subscribe((response) => {

			});
		});
		*/
	}

}
